<template>
  <div>
    <div class="gd-background pb-5" v-if="currentOutlet">
      <section><!--franchise-->
        <div style="background-image: url(/static/img/background-franchise.png); background-size: cover;" class="px-3">
          <v-layout column align-center justify-start class="white--text mr-5 mb-3 pt-3">
            <div class="white--text mt-5 text-md-center">
              <h1 class="text-executive-lg uppercase text-shadow">{{ currentOutlet.name }}</h1>
            </div>
          </v-layout>
          <v-layout column align-center justify-end class="mt-5">
            <div class="gd-blue-franchise gd-middle-box">
              <div class="text-morsal-lg mb-5 text-md-center"> <!-- gd-rotate-3"> -->
                <h1>
                  Visit us
                </h1>
              </div>
              <OutletAddressCard :current-outlet="currentOutlet"/>
            </div>
          </v-layout>
        </div>
      </section>

      <section>
        <v-flex>
          <iframe
            id="gmap_canvas"
            width="100%"
            height="480"
            :src="currentOutlet.google_location"
            frameborder="0"
            scrolling="no"
            marginheight="0"
            style="filter: opacity(0.7);"
            marginwidth="0"/>
        </v-flex>
        <v-flex xs12 md12 class="my-5 mx-5">
          <div class="text-md-center text-xs-center text-helvetica-lg uppercase underline">
            <h2>⭐ {{ currentOutlet.name }} GALLERY ⭐</h2>
          </div>
        </v-flex>
        <v-flex>
          <div class="image_preview">
            <v-dialog max-width="600px" v-model="imgPreview" @input="imgPreview = false">
              <v-card class="gd-background">
                <v-card-text>
                  <img class="image-preview" :src="mainImage" :alt="mainImage">
                </v-card-text>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn color="blue darken-1" flat @click.native="imgPreview = false">Close</v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
          </div>
          <v-container grid-list-xl class="white--text text-lg-center mb-5">
            <v-layout row wrap align-center justify-center>
              <v-container grid-list-xxl>
                <v-layout row wrap align-center>
                  <v-flex xs12 sm6 md4 :key="data.id" v-for="data in outletPhotos">
                    <figure class="pointer outlet-image-container">
                      <img :src="getPath(data.image_url)" alt="Kopi Ketjil" class="outlet-image"
                           @click="openImage(getPath(data.image_url))">
                    </figure>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-layout>
          </v-container>
        </v-flex>
      </section>
    </div>
  </div>
</template>

<script>
import {mapGetters} from 'vuex'
import OutletAddressCard from '@/views/OutletAddressCard.vue'

export default {
  name: 'outlet-detail',
  components: {OutletAddressCard},
  data () {
    return {
      imgPreview: false,
      mainImage: ''
    }
  },
  computed: {
    ...mapGetters(['outlets']),
    paramsOutletId () {
      return this.$route.params.outletId
    },
    paramsRegionId () {
      return this.$route.params.regionId
    },
    currentOutlet () {
      return this.outlets.find(outlet => outlet.id.toString() === this.paramsOutletId.toString())
    },
    outletPhotos () {
      return this.currentOutlet.photos || []
    }
  },
  created () {
    this.getOutlets()
  },
  methods: {
    getPath (fileName) {
      if (fileName === undefined) {
        return '/static/img/news/default-210.png'
      }
      if (fileName.startsWith('http')) {
        return fileName
      }
      return 'https://api.kopiketjil.com' + fileName
    },
    openImage (path) {
      // window.open(path)
      this.imgPreview = true
      this.mainImage = path
    },
    getOutlets () {
      this.$store.dispatch('getOutlets', {
        data: {
          region_id: this.paramsRegionId
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.outlet-image-container {
  width: 360px;
  height: 360px;
  overflow: hidden;
  @media screen and (max-width: 960px - 1px) {
    width: 100%;
    height: 280px;
  }
}

.outlet-image {
  background-size: cover;
  transition: transform 0.3s;
  object-fit: cover;

  &:hover {
    transform: scale(1.1);
  }
}

.image-preview {
  width: 100%;
  height: 100%;
  img {
    width: 100%;
    height: 100%;
    object-fit: contain;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/OutletDetail.vue